<app-toolbar [menu]="menu" *ngIf="isLoggedIn"></app-toolbar>
<app-navbar *ngIf="isLoggedIn"></app-navbar>


<ng-content></ng-content>

<div class="sidenav-overlay" (click)="cerrarMenuMovil()"></div>
<div class="drag-target"></div>
<app-footer [ngClass]="{'ml-0': !isLoggedIn}"></app-footer>
